import React from "react";
import { Container, Grid, Card, Box, Typography, Stack } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faServer, faFire, faSitemap, faCloud } from "@fortawesome/free-solid-svg-icons";
import SectionHeading from "./SectionHeading";
import { colors, fonts, ui } from "../theme";

const tracks = [
  { days: "15", title: "Foundation Track", text: "Foundational architectures, core logical operations and local Git version control." },
  { days: "30", title: "Technical Immersion", text: "Dynamic database systems, user verification protocols and automated testing engines." },
  { days: "45", title: "Innovation Sprint", text: "Microservice patterns, API gateways and cloud deployment pipelines." },
  { days: "60", title: "Professional Readiness", text: "Enterprise DevOps, automated containers and performance-scaling optimisation." },
];

const pathways = [
  {
    icon: faServer,
    title: "Node.js Enterprise Backend",
    text: "Scalable server architectures with Express.js, query optimisation and secure JWT authentication.",
  },
  {
    icon: faFire,
    title: "Modern Frontend with Firebase",
    text: "Responsive interfaces with real-time cloud data storage and custom security rulesets.",
  },
  {
    icon: faSitemap,
    title: "Problem Solving with DSA",
    text: "Optimised, clean code patterns and memory-management strategies expected by top product firms.",
  },
  {
    icon: faCloud,
    title: "Enterprise Cloud Foundations",
    text: "Cloud services, automated deployment frameworks and containerised architectures.",
  },
];

const TrainingCards = () => {
  return (
    <section id="training-section" className="training-section">
      <Box sx={{ background: colors.bgGradient, py: { xs: 5, md: 7 } }}>
        <Container>
          <SectionHeading
            eyebrow="Internship & Project Excellence Ecosystem"
            title="Milestone-Driven Tracks That Build Real, Practical Skill"
            subtitle="A clear, structured progression — from foundations to enterprise-grade DevOps — so every student develops verifiable technical capability."
          />

          {/* Milestone tracks */}
          <Grid container spacing={3} sx={{ mb: 6 }}>
            {tracks.map((t) => (
              <Grid item xs={12} sm={6} lg={3} key={t.days}>
                <Card
                  elevation={0}
                  sx={{
                    ...ui.cardHover,
                    height: "100%",
                    p: 3,
                    borderRadius: 3,
                    border: "1px solid #e6edf7",
                    bgcolor: colors.white,
                    position: "relative",
                  }}
                >
                  <Stack direction="row" alignItems="baseline" spacing={0.5} sx={{ mb: 1.5 }}>
                    <Typography
                      sx={{ fontFamily: fonts.heading, fontWeight: 800, fontSize: "2.2rem", color: colors.blueInk, lineHeight: 1 }}
                    >
                      {t.days}
                    </Typography>
                    <Typography sx={{ fontWeight: 700, color: colors.navy, fontSize: "0.9rem" }}>DAYS</Typography>
                  </Stack>
                  <Typography sx={{ fontFamily: fonts.heading, fontWeight: 700, color: colors.navy, mb: 0.8 }}>
                    {t.title}
                  </Typography>
                  <Typography sx={{ color: colors.textMuted, fontSize: "0.88rem", lineHeight: 1.6 }}>
                    {t.text}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>

          <SectionHeading eyebrow="High-Demand Specialisation Pathways" title="Where Students Go Deep" />
          <Grid container spacing={3}>
            {pathways.map((p) => (
              <Grid item xs={12} sm={6} key={p.title}>
                <Card
                  elevation={0}
                  sx={{
                    ...ui.cardHover,
                    height: "100%",
                    p: 3,
                    borderRadius: 3,
                    border: "1px solid #e6edf7",
                    bgcolor: colors.white,
                    display: "flex",
                    gap: 2.5,
                    alignItems: "flex-start",
                  }}
                >
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      minWidth: 52,
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: colors.blueTint,
                      color: colors.blueDark,
                      border: "1px solid rgba(56,182,255,0.22)",
                    }}
                  >
                    <FontAwesomeIcon icon={p.icon} style={{ fontSize: "1.4rem" }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontFamily: fonts.heading, fontWeight: 700, color: colors.navy, mb: 0.6 }}>
                      {p.title}
                    </Typography>
                    <Typography sx={{ color: colors.textMuted, fontSize: "0.9rem", lineHeight: 1.6 }}>
                      {p.text}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </section>
  );
};

export default TrainingCards;
